var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAtAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0.421875C17.8137 0.421875 20.5 3.10817 20.5 6.42188V14.4219C20.5 17.7356 17.8137 20.4219 14.5 20.4219H6.5C3.18629 20.4219 0.5 17.7356 0.5 14.4219V6.42188C0.5 3.10817 3.18629 0.421875 6.5 0.421875H14.5ZM6.5 13.1055V14.9053H14.5V13.1055H6.5ZM7.40039 7.22168L6.2998 6.17188L5.25 7.22168L6.2998 8.32227L5.25 9.37207L6.2998 10.4219L7.40039 9.37207L8.4502 10.4219L9.5 9.37207L8.4502 8.32227L9.5 7.22168L8.4502 6.17188L7.40039 7.22168ZM13.5996 7.22168L12.5498 6.17188L11.5 7.22168L12.5498 8.32227L11.5 9.37207L12.5498 10.4219L13.5996 9.37207L14.7002 10.4219L15.75 9.37207L14.7002 8.32227L15.75 7.22168L14.7002 6.17188L13.5996 7.22168Z",
    fill: "#F34720"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAtAll);
export default __webpack_public_path__ + "static/media/not_at_all.2cdffad9dcd7c1bb741ef6cf4d3d5a07.svg";
export { ForwardRef as ReactComponent };